module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container"
  }, [_c('div', {
    staticClass: "d-guides"
  }, [_c('StilGuides', {
    attrs: {
      "video-id": '5Id4TeuHMvI?start=233',
      "textForLink": "Guide: Se videoguide for kompetencedækning"
    }
  }), _vm._v(" "), (_vm.isShowSubjects) ? _c('p', {
    staticClass: "italic"
  }, [_c('b', [_vm._v("Bemærk:")]), _vm._v(" Opret, slet eller redigere fag påvirker kun indberetningsdata'en - ikke i resten af Docendo")]) : _vm._e()], 1), _vm._v(" "), (_vm.usersSorted.length < 1) ? _c('h3', {
    staticClass: "text-explainer text-explainer__error"
  }, [_c('svg', {
    staticClass: "tw-icon icon-important",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
    }
  })]), _vm._v("\n    Der er ingen personer udfyldt med stilling og CPR. Gå tilbage til \"1. Undervisningskompetencer\"\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersSorted), function(user) {
    return _c('KompetenceIndberetningDaekningUser', {
      attrs: {
        "user": user,
        "klokketimetyper": _vm.klokketimetyper,
        "dbStilData": _vm.dbStilData
      },
      on: {
        "updateStil": function($event) {
          return _vm.$emit('updateStil', $event)
        }
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-098a0e7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningDaekning.vue
// module id = 1751
// module chunks = 1